import reducer from './reducer'

import * as dealScreenSelectors from './selectors'

export { dealScreenSelectors }

export default reducer
